/* eslint-disable no-var */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Modal, Row, Col } from 'react-bootstrap';
import { SimpleCard } from '../../Card';
import { SimpleTag } from '../../tags';
import {
  HeadingDesc,
  HeadingDescSmall,
  HeadingWithSpaceLarge,
  SectionHeadingMed,
  SectionHeadingSmall
} from '../../Headings';
import { SimpleAncer } from '../../button';
import docImage from '../../../assets/images/png/article2.png';
import closeIcon from '../../../assets/images/svg/modal-close.svg';
import './appointmentConfirmModal.css';

function AppointmentConfirmModal(props) {
  const { show, close } = props;

  return (
    <Modal
      show={show}
      className="modalLayout appointmentConfirmModal"
      onHide={close}
      centered
      aria-labelledby="containoded-mal-title-vcenter"
    >
      <Modal.Body>
        <div className="content">
          <button type="button" className="modalCloseBtn" onClick={close}>
            <img src={closeIcon} alt="closeIcon" />
          </button>
          <Row>
            <SectionHeadingMed text="Your Appointment is confirmed!" />
            <Col md={7}>
              <HeadingDesc text="Here are the details. You can edit any information from the user account area." />
            </Col>
            <Col md={10}>
              <SimpleCard>
                <Row className="docInfoCard">
                  <Col md={3}>
                    <div className="imgBox">
                      <img src={docImage} alt="docImage" />
                    </div>
                  </Col>
                  <Col md={9}>
                    <div className="info">
                      <div className="docName">
                        <SectionHeadingSmall text="Dr. Madeeha Asad" />
                      </div>
                      <div className="speciality">
                        <HeadingDesc text="Tomorrow, Apr 7 - 9:45 am at DHA Medical Centre" />
                      </div>
                      <div className="availabe one">
                        <HeadingDesc text="In-Person Appointment" />
                      </div>
                      <SimpleTag text="2000" />
                    </div>
                  </Col>
                </Row>
              </SimpleCard>
              <div className="btnsContainer">
                <SimpleAncer text="READ ARTICLES RELATED TO YOUR APPOINTMENT" />
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AppointmentConfirmModal;
